import { ProjectConfig } from "./types";

export const outborn: ProjectConfig = {
  slug: "outborn",
  // Single square emblem (see public/branding/outborn/) — doubles as the header
  // mini mark and the welcome BigLogo. Served from /public, so it loads as fast
  // as the old bundled art. Same file the API serves as the study/email logo.
  logo: "/branding/outborn/logo.png",
  miniLogo: "/branding/outborn/logo.png",
  homeExperience: "questionnaires",
  // Default onboarding type when a study's ONBOARDING-STUDY page carries no
  // explicit type yet: multi-screen swiper (content split on EditorJS delimiter
  // (* * *) blocks). Researchers pick the type per-study in Diapason.
  onboardingStyle: "swiper",
  // "suivi" is the investigator dashboard (role-gated in studyTabs.ts): listed
  // FIRST so investigators land on it; subjects never see it and land on the
  // next role-free tab (questionnaires). "calendar" is the subject agenda
  // (subject-role-gated): open + upcoming questionnaires. "invitation" is the
  // subject-role-gated invite page (a parent inviting the second parent / a
  // relative into their own dossier); staff invite from the Suivi dossier flow.
  tabs: ["suivi", "questionnaires", "calendar", "invitation", "account"],
  // No burger: "account" (Compte) already carries every entry the menu had, and
  // carries them better (notifications, opposition SNDS, mentions légales). The
  // one thing Compte cannot reach — the language selector on the logged-out
  // welcome/signup screens — is moot here: Outborn is French-only, so that modal
  // would list a single already-checked row. Revisit if a study adds a language.
  // (Empty right slot = no burger; left keeps the default logo.)
  header: {
    right: [],
  },
  // Landing copy — Outborn IS a clinical research study, so the wording signals a
  // serious, trustworthy programme (vs Mental+'s well-being framing). No
  // partnerLogos → the landing shows no funder strip.
  welcome: {
    fr: {
      badge: "Étude de recherche",
      title: "Outborn Transfer",
      tagline:
        "Vous participez à une étude de recherche clinique. Connectez-vous pour poursuivre votre suivi.",
      note: "Vos données sont traitées de façon sécurisée et confidentielle dans le cadre de l'étude.",
    },
    en: {
      badge: "Research study",
      title: "Outborn Transfer",
      tagline:
        "You are taking part in a clinical research study. Sign in to continue your follow-up.",
      note: "Your data is processed securely and confidentially as part of the study.",
    },
  },
  // Build-time default = Outborn's live THEME (Diapason's "Océan" preset: blue
  // header and tab bar, amber CTAs, cyan answers; Quicksand text, Outfit titles).
  // It paints before the THEME study_config arrives (and whenever none is
  // saved), so keeping the two identical avoids a flash of another palette.
  // The THEME config in Diapason stays the source of truth — no deploy needed.
  theme: {
    colors: {
      primary: "#0369a1",
      secondary: "#f59e0b",
      accent: "#0891b2",
      background: "#f8fafc",
      surface: "#ffffff",
      text: "#0f172a",
    },
    font: "Quicksand",
    fontTitle: "Outfit",
  },
};
